import styled from "styled-components";

export const StyledQuestionDetail = styled.div`
  .question-detail-container {
    padding: 10px 20px 20px;
    direction: rtl;
  }
`;
